import React from 'react';
export var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M416 128L192 384l-96-96",
    className: "ionicon-fill-none ionicon-stroke-width"
  }));
};
export var MinusIcon = function MinusIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M400 256H112",
    className: "ionicon-fill-none ionicon-stroke-width"
  }));
};
export var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "ionicon close-icon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M368 368L144 144M368 144L144 368",
    className: "ionicon-fill-none ionicon-stroke-width"
  }));
};